import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { PageBase } from 't4core';
import { InvoiceSpecification } from 't4core';



@Component({
    selector: 'invoice',
    templateUrl: './Invoice.html',
    styleUrls: ['./Invoice.css']
})
export class InvoiceComponent extends PageBase implements OnInit {
    public toDate: moment.Moment = moment().endOf('month');
    public fromDate: moment.Moment = moment().startOf('month').add(-1, 'year');

    constructor(private router: Router, private route: ActivatedRoute, el: ElementRef) {
        super(el, "OneWayAdmin");
    }

    public months: string[] = [];
    public invoices: InvoiceSpecification[] = [];

    public async ngOnInit() {
        this.loadInvoices();
    }

    public async loadInvoices() {
        this.invoices = await this.Api.get<InvoiceSpecification[]>("/OneWay/GetInvoices", { from: this.fromDate, to: this.toDate });      
    }
}
